// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__JPr7v"};